import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { key } from '@/store';
import { getQuizFilters } from '@/api/QuizApi';

let pendingRequest: Promise<number> | null = null;

export default function useBusinessFunctionId() {
  const store = useStore(key);
  const businessFunctionId = computed(() => store.state.businessFunctionId);

  const loadBusinessFunctionId = () => {
    if (store.state.businessFunctionId !== -1 || pendingRequest) {
      return;
    }

    pendingRequest = getQuizFilters()
      .then(res => {
        const id = res['business_function'].question_template_id;
        store.commit('setBusinessFunctionId', id);
        return id;
      })
      .finally(() => {
        pendingRequest = null;
      });
  };

  onMounted(loadBusinessFunctionId);

  return businessFunctionId;
}
